var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.isNone)?_c('v-chip',{attrs:{"color":_setup.color}},[_vm._v(" "+_vm._s(_setup.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }